import React, { Component } from 'react';
import PropTypes from 'prop-types';
import List from '@researchgate/react-intersection-list';
import Loader from 'react-loader';

import IconTrash from '../icons/IconTrash';
import AsyncImage from '../components/AsyncImage';

export const DEFAULT_PAGE_SIZE = 30;

export default class ImageList extends Component {
  static propTypes = {
    pageSize: PropTypes.number,
    onIntersection: PropTypes.func,
    images: PropTypes.arrayOf(PropTypes.object),
    totalImages: PropTypes.number,
    threshold: PropTypes.string,
    cursor: PropTypes.string,
    onSelectImage: PropTypes.func,
    onDeleteImage: PropTypes.func,
    asyncUrlProvider: PropTypes.func
  };

  static defaultProps = {
    pageSize: DEFAULT_PAGE_SIZE,
    onIntersection: () => {},
    onSelectImage: () => {},
    asyncUrlProvider: () => Promise.resolve(),
    onDeleteImage: null,
    cursor: null,
    images: [],
    totalImages: 0,
    threshold: '250px'
  };

  renderItem = (index, key) => {
    const { totalImages, images, onSelectImage, onDeleteImage, asyncUrlProvider, cursor } = this.props;
    const img = images[index];
    const showLoader = index === images.length - 1 && (images.length < totalImages || cursor);
    return (
      <React.Fragment key={key}>
        <figure className="ImageBrowsePanel__imageContainer" title={img.title} onClick={() => onSelectImage(img)}>
          <AsyncImage
            showLoadingSpinner={true}
            className="ImageBrowsePanel__image"
            assetId={img.id}
            bucketUrl={img.bucketUrl}
            imageFilename={img.imageFilename}
            asyncUrlProvider={asyncUrlProvider}
            thumb={true}
          />
          {typeof onDeleteImage === 'function' && (
            <button className="ImageBrowsePanel__deleteButton" onClick={e => onDeleteImage(e, img)}>
              <IconTrash />
            </button>
          )}
        </figure>
        {showLoader ? (
          <figure className="ImageBrowsePanel__imageContainer ImageBrowsePanel__imageContainer--transparent">
            <Loader loaded={false} />
          </figure>
        ) : null}
      </React.Fragment>
    );
  };

  imagesRenderer(images, ref) {
    return (
      <div className="ImageBrowsePanel__libraryList" ref={ref}>
        {images}
      </div>
    );
  }

  render() {
    const { images, pageSize, onIntersection, threshold } = this.props;
    return (
      <List
        pageSize={pageSize - 1}
        threshold={threshold}
        onIntersection={onIntersection}
        items={images}
        renderItem={this.renderItem}
        itemRenderer={this.imagesRenderer}
      />
    );
  }
}
